export class ConstructorPreloader {
	constructor(wrapperSelector = ".mc-wrapper") {
		this.$wrapper = jQuery(wrapperSelector);
		this.$overlay = this.$wrapper.find(".mc-preloader");
	}

	show(message) {
		if (message) {
			this.setMessage(message);
		}

		if (this.$wrapper.length) {
			this.$wrapper.addClass("mc-is-loading");
		}

		if (this.$overlay.length) {
			this.$overlay.removeClass("is-hidden");
		}
	}

	hide() {
		if (this.$wrapper.length) {
			this.$wrapper.removeClass("mc-is-loading");
		}

		if (this.$overlay.length) {
			this.$overlay.addClass("is-hidden");
		}
	}

	setMessage(message) {
		if (!this.$overlay.length) return;
		const $text = this.$overlay.find(".mc-preloader__text");
		if ($text.length) {
			$text.text(message);
		}
	}
}
